import { REACT_QUERY_KEYS } from 'common'
import { TEntity, TLanguage } from 'contexts/app-context/types'
import { Answer } from 'pages/frequent-questions/components/faq-card'
import { getFAQAnswer } from 'pages/frequent-questions/repository/frequent-questions'

import { queryOptions } from '@tanstack/react-query'

interface GetFaqAnswerQueryParams {
  id: string
  language: TLanguage
  userSelectedEntity: TEntity
}

const getFaqAnswerQueryKey = ({ id, language, userSelectedEntity }: GetFaqAnswerQueryParams) => [
  REACT_QUERY_KEYS.FAQ_ANSWER,
  id,
  language,
  userSelectedEntity,
]

const getFaqAnswerQueryOptions = ({ id, language, userSelectedEntity }: GetFaqAnswerQueryParams) =>
  queryOptions<Answer>({
    queryKey: getFaqAnswerQueryKey({ id, language, userSelectedEntity }),
    queryFn: () => getFAQAnswer(id, language, userSelectedEntity),
    staleTime: 1000 * 60 * 3,
    gcTime: 1000 * 60 * 9,
  })

export type { GetFaqAnswerQueryParams }
export { getFaqAnswerQueryKey, getFaqAnswerQueryOptions }
